import React, { Component } from "react";
import { connect } from "react-redux";

import {
  ModalContainer,
  KeyboardView,
  Wrapper,
  Title,
  Copy,
  Bold,
  ExternalImage,
  Row,
  ContentfulRichText
} from "app/NativeComponents/common";
import { Header, PillButton } from "app/NativeComponents/snippets";

import {
  loadOnboardingText,
  appRedirect,
  openUrl,
  checkIfUserHasModule
} from "app/NativeActions";

class OnboardingComplete extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onboarding_content: null,
      loading: false,
      onboarding_slug: "completedOnboarding"
    };

    this.handleBack = this.handleBack.bind(this);
  }

  componentDidMount() {
    const plan_module_info = checkIfUserHasModule({
      plan_modules: this.props.plan_modules,
      user: this.props.user,
      slug:
        this.props.plan_modules.length != 0
          ? this.props.plan_modules[0].module_type
          : "crm"
    });
    let onboarding_slug = "completedOnboarding";
    if (plan_module_info.slug == "messages") {
      onboarding_slug = "completedOnboardingMessages";
    } else if (plan_module_info.slug == "lists") {
      onboarding_slug = "completedOnboardingLists";
    } else if (plan_module_info.slug == "crm") {
      onboarding_slug = "completedOnboardingCRM";
    }
    this.setState({
      onboarding_slug: onboarding_slug
    });

    loadOnboardingText(onboarding_slug)
      .then(data => {
        if (data && data.items && data.items.length > 0) {
          this.setState(() => ({
            onboarding_content: data.items[0]
              ? data.items[0].fields
                ? data.items[0].fields
                : null
              : null,
            loading: false
          }));
        }
        this.setState(() => ({ loading: false }));
      })
      .catch(err => {
        this.setState(() => ({ loading: false }));
      });
  }

  renderImage(onboarding_content) {
    if (onboarding_content.image) {
      return (
        <ExternalImage
          style={{
            resizeMode: "contain",
            width: 150,
            height: 150,
            margin: 20
          }}
          contain={true}
          image={onboarding_content.image.fields.file.url}
        />
      );
    }
  }

  renderContent(onboarding_content) {
    if (onboarding_content.richContent) {
      return (
        <ContentfulRichText
          style={{ textAlign: "center" }}
          richText={onboarding_content.richContent}
        />
      );
    }
  }

  renderButton(onboarding_content) {
    if (onboarding_content.buttonText && onboarding_content.buttonLink) {
      return (
        <Row style={{ justifyContent: "center" }}>
          <PillButton
            primary={true}
            onPress={() => {
              openUrl(onboarding_content.buttonLink);
            }}
          >
            {onboarding_content.buttonText}
          </PillButton>
        </Row>
      );
    }
  }

  handleBack() {
    if (this.state.onboarding_slug == "completedOnboardingMessages") {
      this.props.appRedirect({
        redirect: "message_engine"
      });
    } else if (this.state.onboarding_slug == "completedOnboardingLists") {
      this.props.appRedirect({
        redirect: "list_builder"
      });
    } else if (this.state.onboarding_slug == "completedOnboardingCRM") {
      this.props.appRedirect({
        redirect: "dashboard"
      });
    } else {
      this.props.appRedirect({
        redirect: "goBack",
        payload: { type: "dashboard" }
      });
    }
  }

  render() {
    const { onboarding_content, loading } = this.state;
    if (onboarding_content && !loading) {
      return (
        <ModalContainer>
          <Header
            title={onboarding_content.title}
            leftButtonIcon={"close"}
            leftButtonAction={this.handleBack}
          />
          <KeyboardView>
            <Wrapper
              style={{
                padding: 20,
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              {this.renderImage(onboarding_content)}
              <Title style={{ textAlign: "center" }}>
                {onboarding_content.description}
              </Title>
              {this.renderContent(onboarding_content)}
              {this.renderButton(onboarding_content)}
            </Wrapper>
          </KeyboardView>
        </ModalContainer>
      );
    }
    return <Wrapper />;
  }
}

const mapStateToProps = ({ auth, native, billing }) => {
  const { token, user } = auth;
  const { device, platform } = native;
  const { plan_modules } = billing;
  return {
    token,
    user,
    device,
    platform,
    plan_modules
  };
};

export default connect(mapStateToProps, {
  appRedirect
})(OnboardingComplete);
